import { Suspense, lazy, useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { DEVICE_TYPES, PAGES_URL } from "./shared/constants/constants";
import customTheme from "./shared/models/theme";
import SessionExpirationTimer from "./shared/components/sessionExpireTimer/sessionExpireTimer";

import useDisableInspect from "./shared/hooks/useDisableInspect";
import { getEnvName } from "./shared/utils/utils";
import { store } from "./store/store";
import CustomWindowSize from "./shared/hooks/useWindowSize";
import { setBrowserDeviceType } from "./store/reducers/browserConfig";
import { Box } from "@mui/material";
import Authentication from "./pages/authentication/authStructure/authentication";
import Header from "./components/header/header";
import PrivateRoutes from "./components/privateRoute/privateRoute";
import Home from "./pages/home/home";
import OrderTable from "./pages/orders/orderTable/orderTable";
import GRNTable from "./pages/grn/grnTable/grnTable";
import InvoiceTable from "./pages/invoice/invoiceTable/invoiceTable";
const envName = getEnvName();

const theme = customTheme;

// <PermissionedRoute path='MyRFQs/CreateRFQ' element={<CreateRFQ />} permissions={[PLATFORM_PERMISSIONS.REQUEST_CREATE]} />

function App() {
  const customWindowSize = CustomWindowSize();

  useEffect(() => {
    if (customWindowSize.width <= 480) {
      store.dispatch(setBrowserDeviceType(DEVICE_TYPES.MOBILE));
    } else if (customWindowSize.width > 1024) {
      store.dispatch(setBrowserDeviceType(DEVICE_TYPES.DESKTOP));
    } else {
      store.dispatch(setBrowserDeviceType(DEVICE_TYPES.TABLET));
    }
  }, [customWindowSize.width]);

  // useDisableInspect();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box className="App">
        <Header />
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", flexGrow: 1 }}>
          <BrowserRouter>
            <Suspense>
              <Routes>
                <Route element={<PrivateRoutes />}>
                  {/* HOME */}
                  <Route path={PAGES_URL.HOME} element={<Home />} />

                  {/* ORDERS */}
                  <Route path={PAGES_URL.ORDER_MGR} element={<OrderTable />} />

                  {/* GRN */}
                  <Route path={PAGES_URL.GRN_MGR} element={<GRNTable />} />

                  {/* INVOICE */}
                  <Route path={PAGES_URL.INVOICE_MGR} element={<InvoiceTable />} />
                </Route>
                
                <Route path={"/"} element={<Authentication />} />
                <Route path={PAGES_URL.SIGN_IN} element={<Authentication />} />
              </Routes>
              <SessionExpirationTimer />
            </Suspense>
          </BrowserRouter>
        </Box>
      </Box>
    </ThemeProvider>
  );
}

export default App;
